// Google Maps Configuration
// For testing, you can use a free API key from Google Cloud Console
// Get a free key at: https://console.cloud.google.com/apis/credentials

// Frontend API Key for Google Maps (backup)
const FRONTEND_API_KEY = 'AIzaSyB_heN1_Og5sVWkZSdEWThgbjLXA5gzJw8';
// Production API Key - This will be used as fallback
const PRODUCTION_API_KEY = 'AIzaSyBClMpoJKcjUE4KZR5mrMf-d8XNfrIlE98';

// Helper function to get API key for current environment
const getApiKeyForEnvironment = () => {
  // Use environment variable if available, otherwise fallback to hardcoded key
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || PRODUCTION_API_KEY;
};

// Get the actual API key to use
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || PRODUCTION_API_KEY;

export const GOOGLE_MAPS_CONFIG = {
  API_KEY: API_KEY,
  LIBRARIES: ['places'], // Only load places library for autocomplete
  DEFAULT_CENTER: {
    lat: -25.2744, // Center of Australia
    lng: 133.7751
  },
  DEFAULT_ZOOM: 13,
  MAP_OPTIONS: {
    zoomControl: true,
    streetViewControl: false,
    mapTypeControl: true,
    fullscreenControl: false,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
  }
};

// Helper function to validate API key
export const validateApiKey = () => {
  const apiKey = GOOGLE_MAPS_CONFIG.API_KEY;
  return apiKey && apiKey !== 'YOUR_GOOGLE_MAPS_API_KEY';
};

// Helper function to get API key with validation
export const getApiKey = () => {
  if (!validateApiKey()) {
    console.warn('Google Maps API key not configured. Please set REACT_APP_GOOGLE_MAPS_API_KEY in your environment variables.');
    return null;
  }
  return GOOGLE_MAPS_CONFIG.API_KEY;
};

// Development mode check
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Export the function for external use
export { getApiKeyForEnvironment };
